<template>
  <DefaultLayout>
  <div>
    <!-- Verification Section Begin -->
    <div class="register-login-section spad">
      <div class="container">
        <div class="row">
          <div
            class="text-center col-lg-8 offset-lg-2 alert alert-danger"
            v-if="has_error && !success"
          >
            <p v-if="error !== null">
              {{ error }}
            </p>
            <p v-else>
              {{ $t("auth.error.message", { action: $t("auth.login") }) }}
            </p>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default {
  data() {
    return {
      id: "",
      hash: "",
      expires: "",
      signature: "",
      has_error: false,
      error: "",
      errors: {},
      success: false,
      loader: false,
    };
  },
  components: {
    DefaultLayout,
  },
  beforeMount() {
    var app = this;
    app.loader = true;
    let id = this.$route.params.id;
    let hash = this.$route.query.hash;
    let expires = this.$route.query.expires;
    let signature = this.$route.query.signature;

    let url =
      "email/verify/" +
      id +
      "?expires=" +
      expires +
      "&hash=" +
      hash +
      "&signature=" +
      signature;

    this.$store
      .dispatch("verifyEmail", { url })
      .then(() => {
        app.loader = false;
        this.$router.push("/login");
      })
      .catch(function() {
        app.has_error = true;
        app.loader = false;
      });
  },
};
</script>
